import { render, staticRenderFns } from "./NavigationTopCommunication.vue?vue&type=template&id=d4cc6fe8&scoped=true"
import script from "./NavigationTopCommunication.vue?vue&type=script&lang=js"
export * from "./NavigationTopCommunication.vue?vue&type=script&lang=js"
import style0 from "./NavigationTopCommunication.vue?vue&type=style&index=0&id=d4cc6fe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cc6fe8",
  null
  
)

export default component.exports